document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('cart:updated', () => {
    const cartIcon = document.querySelector('.header-actions__cart-icon');
    if (cartIcon) {
      cartIcon.classList.remove('cart-bounce');
      void cartIcon.offsetWidth; // reset animation
      cartIcon.classList.add('cart-bounce');
    }
  });
});
